import React, { useState, useEffect } from "react";
import {
    Paper,
    Typography,
    makeStyles,
    TextField,
    Grid,
    FormControl,
    Radio,
    RadioGroup,
    FormLabel,
    FormControlLabel,
    Icon,
    Fab,
    Button,
    Divider,
    darken,
    Backdrop,
    ButtonGroup,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";

import MomentUtils from "@date-io/moment";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import clsx from "clsx";
import Feedback from "../../../atoms/Feedback";
import { getCRF } from "../../../../actions/ppmActions/changeMgtActions";
import { getProfile } from "../../../../actions/userActions";

// Board
import ApproveChangeRequest from "./_modals/ApproveChangeRequest";
import RejectChangeRequest from "./_modals/RejectChangeRequest";

// Coordinator
import ReviewChangeRequest from "./_modals/ReviewChangeRequest";
import DeclineChangeRequest from "./_modals/DeclineChangeRequest";

// Coordinator
import AcceptChangeRequest from "./_modals/AcceptChangeRequest";
import UnacceptChangeRequest from "./_modals/UnacceptChangeRequest";

const useStyles = makeStyles((theme) => ({
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold",
        marginBottom: 10,
    },
    title2: {
        display: "block",
        fontSize: 14,
        marginBottom: 10,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontWeight: "bold",
        fontFamily: "Rubik",
    },
    title3: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
    },
    appBar: {
        zIndex: 9000,
    },
    container: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    paper1: {
        padding: theme.spacing(3),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.15) : darken("#fff", 0.80),
    },
    paper0: {
        padding: theme.spacing(2),
        marginBottom: 20,
        paddingBottom: 0,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.05) : darken("#fff", 0.80),
    },
    paper2: {
        marginBottom: 20,
        background: theme.palette.type === "light" ? darken("#fff", 0.05) : darken("#fff", 0.80),
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginRight: 10,
            fontSize: 18,
        },
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    paper23: {
        padding: "2px 20px 2px 5px",
        width: "60%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
            width: "100%",
        },
        "&:nth-of-type(2n)": {
            color: theme.palette.background.paper,
            backgroundColor: theme.palette.primary.main,
        },
    },
    dialogContent: {
        [theme.breakpoints.down("sm")]: {
            padding: "8px 14px",
        },
    },
    tabPanel: {
        padding: 14,
    },
    divider: {
        marginBottom: 10,
    },
    divider2: {
        height: 24,
        margin: 4,
        color: "#fff",
    },
    total: {
        marginTop: 40,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    warningInfo: {
        color: "#f5f5f5",
        background: "#f44336",
        padding: 20,
        marginBottom: 20,
        marginRight: 10,
        "& > *": {
            fontWeight: 900,
        },
    },
    form: {
        marginTop: 20,
    },
    grid: {
        marginBottom: 10,
    },
    input: {
        border: "1px solid #bdbdbd",
        padding: theme.spacing(2),
        borderRadius: 3,
    },

    btnWrapper: {
        textAlign: "center",
    },

    saveBtn: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    saveBtn2: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        background: "#388e3c",
        color: "#fff",
        "&:hover": {
            background: darken("#388e3c", 0.15),
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    backBtn: {
        letterSpacing: 2.5,
        padding: theme.spacing(1.2),
        paddingLeft: 20,
        paddingRight: 20,
    },
    status: {
        width: "fit-content",
        color: "#979292",
        padding: theme.spacing(0.6),
        background: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor:"#fefefe"
    },
    statusTitle: {
        color: "#b5b5b5",
        fontSize: "0.75rem",
    },
    statusTitle2: {
        color: "#fff",
        fontSize: "0.75rem",
        paddingLeft: 10,
        paddingRight: 10,
    },
    statusDarkGreen: {
        color: "#fff",
        backgroundColor: "#4caf50",
    },
    statusGreen: {
        color: "#fff",
        backgroundColor: "#1de9b6",
    },
    statusYellow: {
        color: "#fbc02d",
        backgroundColor: "#fbc02d",
    },
    statusRed: {
        color: "#fff",
        backgroundColor: "#ef5350",
    },
    statusOrange: {
        color: "#fff",
        backgroundColor: "#ff9800",
    },
    embed: {
        width: "100%",
        height: 100,
        objectFit: "contain",
        objectPosition: "center",
        marginRight: 5,
        cursor: "pointer",
        transition: "all 300ms ease-in-out",
        zIndex: 1,
        "&:hover": {
            transform: "scale(2.5)",
            zIndex: 1000000000000,
        },
    },
    audit: {
        padding: 10,
        fontFamily: "Rubik",
        fontSize: 10,
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditTitle: {
        padding: 10,
        // background: theme.palette.grey[600],
        color: theme.palette.type === "light" ? theme.palette.grey[600] : "#cccccc",
        fontFamily: "Rubik",
        fontSize: 10,
        fontWeight: "bold",
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditContainer: {
        width: "100%",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    small: {
        fontSize: 11,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    link: {
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    centered: {
        textAlign: "center",
    },
    paperBlack: {
        color: "#f5f5f5",
        // background: "#3c3737",
        background: theme.palette.grey.A400,
        marginTop: 10,
        marginBottom: 10,
        padding: 5,
        textAlign: "center",
        maxWidth: 400,
        marginLeft: "auto",
        marginRight: "auto",
    },
    info2: {
        marginBottom: 20,
        fontWeight: 500,
    },
}));

const INIT_STATE = {
    employee: "",
    division: "",
    month: "",
    year: "",
    requestDescription: "",
    requestNo: "",
    justification: "",
    priority: "",
    resourceRequirements: "",
    budgetProjection: "",
    timelines: [],
    outcomes: [],
    riskFactors: [],
    opportunityFactors: [],
    trainingRequired: "",
    reason: "",
    recommendation: "",
    drivingForces: [],
    restrainingForces: [],
    totalRestrainingForces: '',
    totalDrivingForces: '',
};

const INIT_DRIVING = {
    description: "",
    likelihood: "",
}

const INIT_RESTRAINING = {
    description: "",
    likelihood: "",
}

const INIT_RISK = {
    risk: "",
    action: "",
    responsibility: "",
    timeline: "",
}

const INIT_OPPORTUNITY = {
    risk: "",
    action: "",
    responsibility: "",
    timeline: "",
}

const ViewChangeRequest = () => {
    const classes = useStyles();
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);
    const [driving, setDriving] = useState(INIT_DRIVING);
    const [restraining, setRestraining] = useState(INIT_RESTRAINING);
    const [riskFactor, setRiskFactors] = useState(INIT_RISK);
    const [opportunityFactor, setOpportunityFactors] = useState(INIT_OPPORTUNITY);
    const { profile } = useSelector((state) => state.user);
    const { error, loading, crf } = useSelector((state) => state.changeMgt);
    
    const [openApprove, setOpenApprove] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [openReview, setOpenReview] = useState(false);
    const [openDecline, setOpenDecline] = useState(false);
    const [openAccept, setOpenAccept] = useState(false);
    const [openUnaccept, setOpenUnaccept] = useState(false);

    const [feed, setFeed] = useState({
        loading: false,
        open: false,
        message: "",
        success: false,
    });

    useEffect(() => {
        if (error && error !== null) {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: error,
                success: false,
            }));
        }
    }, [error]);

    useEffect(() => {
        dispatch(getProfile())
        dispatch(getCRF(id));
    }, [dispatch, id]);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            requestDescription: (crf && crf.requestDescription) || "",
            requestDate: (crf && crf.requestDate) || "",
            justification: (crf && crf.justification) || "",
            resourceRequirements: (crf && crf.resourceRequirements) || "",
            budgetProjection: (crf && crf.budgetProjection) || "",
            priority: (crf && crf.priority) || "",
            division: (crf && crf.division) || "",
            month: (crf && crf.month) || "",
            year: (crf && crf.year) || "",
            requestNo: (crf && crf.requestNo) || "",

            timelines: (crf && crf.timelines) || [],
            outcomes: (crf && crf.outcomes) || [],
            status: (crf && crf.status) || "",
            documentNo: (crf && crf.documentNo) || "",
            
            riskFactors: (crf && crf.riskFactors) || [],
            opportunityFactors: (crf && crf.opportunityFactors) || [],

            decision: (crf && crf.decision) || "",
            trainingRequired: (crf && crf.trainingRequired) || "",
            recommendation: (crf && crf.recommendation) || "",

            drivingForces: (crf && crf.drivingForces) || [],
            restrainingForces: (crf && crf.restrainingForces) || [],
            
            createdBy: (crf && crf.createdBy) || "",
            createdAt: (crf && moment(crf.createdAt).format("l")) || "",

            submittedBy: (crf && crf.submittedBy) || "",
            submittedAt: (crf && crf.submittedAt) || "",

            approvedBy: (crf && crf.approvedBy) || "",
            approvedAt: (crf && crf.approvedAt) || "",
            approveComment: (crf && crf.approveComment) || "",
            
            rejectedBy: (crf && crf.rejectedBy) || "",
            rejectedAt: (crf && crf.rejectedAt) || "",
            rejectComment: (crf && crf.rejectComment) || "",

            reviewedBy: (crf && crf.reviewedBy) || "",
            reviewedAt: (crf && crf.reviewedAt) || "",
            reviewComment: (crf && crf.reviewComment) || "",

            declinedBy: (crf && crf.declinedBy) || "",
            declinedAt: (crf && crf.declinedAt) || "",
            declineComment: (crf && crf.declineComment) || "",

            acceptedBy: (crf && crf.acceptedBy) || "",
            acceptedAt: (crf && crf.acceptedAt) || "",
            acceptComment: (crf && crf.acceptComment) || "",

            unacceptedBy: (crf && crf.unacceptedBy) || "",
            unacceptedAt: (crf && crf.unacceptedAt) || "",
            unacceptComment: (crf && crf.unacceptComment) || "",

        }));
    }, [crf]);

    const validReviewCheck = () =>
        !state.trainingRequired ||
        !state.recommendation ||
        (state.drivingForces.length === 0) || 
        (state.restrainingForces.length === 0);

    const validAcceptCheck = () =>
        (state.riskFactors.length === 0) || 
        (state.opportunityFactors.length === 0);

    const validApproveCheck = () =>
        !state.decision;

    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };

    const isAdmin = profile
        ? profile &&
        profile.groups &&
        profile.groups.some((grp) => grp.name === "admin") : false;

    const isCoordinator = profile
        ? profile &&
        profile.groups &&
        profile.groups.some(
            (grp) => grp.name === "coordinator" && grp.module === "change_request"
        )
        : false;

    const isQHSEHead = profile
        ? profile &&
        profile.division &&
        ((profile?.division?.code === "QHS") && (profile?.division?.manager === profile._id))
        : false;

    const isBoard = profile
        ? profile &&
        profile.groups &&
        profile.groups.some(
            (grp) => grp.name === "board" && grp.module === "change_request"
        )
        : false;

    // qhse
    const handleOpenAccept = () => {
        setOpenAccept(true);
    };
    const handleCloseAccept = () => {
        setOpenAccept(false);
    };
    const handleOpenUnaccept = () => {
        setOpenUnaccept(true);
    };
    const handleCloseUnaccept = () => {
        setOpenUnaccept(false);
    };

    // change coordinator
    const handleOpenApprove = () => {
        setOpenApprove(true);
    };
    const handleCloseApprove = () => {
        setOpenApprove(false);
    };
    const handleOpenReject = () => {
        setOpenReject(true);
    };
    const handleCloseReject = () => {
        setOpenReject(false);
    };

    // change initiator
    const handleOpenReview = () => {
        setOpenReview(true);
    };
    const handleCloseReview = () => {
        setOpenReview(false);
    };
    const handleOpenDecline = () => {
        setOpenDecline(true);
    };
    const handleCloseDecline = () => {
        setOpenDecline(false);
    };

    const handleDrivingChange = (e) => {
        e.persist();
        setDriving((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleAddDrivingArray = (item) => {
        if (item.description !== "" && item.likelihood !== "") {
            setState((prev) => ({
                ...prev,
                drivingForces: prev.drivingForces.concat([item]),
            }));
            setDriving(INIT_DRIVING);
        }
    };

    const handleRemoveDrivingArray = (i) => {
        setState((prev) => ({
            ...prev,
            drivingForces: prev.drivingForces.filter(
                (_, index) => index !== i
            ),
        }));
    };

    const handleRestrainingChange = (e) => {
        e.persist();
        setRestraining((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleAddRestrainingArray = (item) => {
        if (item.description !== "" && item.likelihood !== "") {
            setState((prev) => ({
                ...prev,
                restrainingForces: prev.restrainingForces.concat([item]),
            }));
            setRestraining(INIT_RESTRAINING);
        }
    };

    const handleRemoveRestrainingArray = (i) => {
        setState((prev) => ({
            ...prev,
            restrainingForces: prev.restrainingForces.filter(
                (_, index) => index !== i
            ),
        }));
    };

    const handleRiskFactorChange = (e) => {
        e.persist();
        setRiskFactors((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleAddRiskFactorsArray = (item) => {
        if (item.risk !== "" && item.action !== "" && item.responsibility !== "" && item.timeline !== "") {
            setState((prev) => ({
                ...prev,
                riskFactors: prev.riskFactors.concat([item]),
            }));
            setRiskFactors(INIT_RISK);
        }
    };

    const handleRemoveRiskFactorsArray = (i) => {
        setState((prev) => ({
            ...prev,
            riskFactors: prev.riskFactors.filter(
                (_, index) => index !== i
            ),
        }));
    };

    const handleOpportunityFactorChange = (e) => {
        e.persist();
        setOpportunityFactors((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleAddOpportunityFactorsArray = (item) => {
        if (item.risk !== "" && item.action !== "" && item.responsibility !== "" && item.timeline !== "") {
            setState((prev) => ({
                ...prev,
                opportunityFactors: prev.opportunityFactors.concat([item]),
            }));
            setOpportunityFactors(INIT_OPPORTUNITY);
        }
    };

    const handleRemoveOpportunityFactorsArray = (i) => {
        setState((prev) => ({
            ...prev,
            opportunityFactors: prev.opportunityFactors.filter(
                (_, index) => index !== i
            ),
        }));
    };

    useEffect(() => {
        if (state.drivingForces && state.drivingForces.length > 0) {
            let totalDrivingForces = state.drivingForces.reduce((acc, cur) => { return acc + +cur.likelihood; }, 0);
            setState((prev) => ({
                ...prev,
                totalDrivingForces: parseInt(totalDrivingForces) || 0
            }));
        }
    }, [state.drivingForces]);

    useEffect(() => {
        if (state.restrainingForces && state.restrainingForces.length > 0) {
            let totalRestrainingForces = state.restrainingForces.reduce((acc, cur) => { return acc + +cur.likelihood; }, 0);
            setState((prev) => ({
                ...prev,
                totalRestrainingForces: parseInt(totalRestrainingForces) || 0
            }));
        }
    }, [state.restrainingForces]);

    return (
        <div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {feed.success ? (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="success"
                        message={feed.message}
                    />
                ) : (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="error"
                        message={feed.message}
                    />
                )}

                {/* Change Board */}
                <ApproveChangeRequest {...{ openApprove, handleCloseApprove, id, data: { decision: state.decision } }} />
                <RejectChangeRequest {...{ openReject, handleCloseReject, id }} />

                {/* Change Coordinator */}
                <ReviewChangeRequest {...{ openReview, handleCloseReview, id, 
                    data: {
                        drivingForces: state.drivingForces,
                        restrainingForces: state.restrainingForces,
                        trainingRequired: state.trainingRequired,
                        recommendation: state.recommendation,
                        path: `change/request/view/${id}`,
                    }
                 }} />
                <DeclineChangeRequest {...{ openDecline, handleCloseDecline, id }} />

                {/* QHSE Review */}
                <AcceptChangeRequest {...{ openAccept, handleCloseAccept, id, 
                    data: {
                        riskFactors: state.riskFactors,
                        opportunityFactors: state.opportunityFactors,
                        path: `change/request/view/${id}`,
                    }
                 }} />
                <UnacceptChangeRequest {...{ openUnaccept, handleCloseUnaccept, id }} />

                <Typography variant="overline" className={classes.title}>
                    View Change Request
                </Typography>

                <Grid container justify="space-between" alignItems="center" spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item>
                        <Button
                            color="primary"
                            variant="contained"
                            className={classes.backBtn}
                            startIcon={<ArrowBackIosIcon />}
                            onClick={() => history.push("/change/requests")}
                        >
                            Back
                        </Button>

                        {((isAdmin || isBoard || isCoordinator || isQHSEHead) && (state.status === "approved")) ? (
                        <Button
                            color="secondary"
                                variant="contained"
                                style={{ marginLeft: 10 }}
                                className={classes.backBtn}
                                onClick={() => history.push(`/change/request/export/${id}`)}
                            >
                                View Document
                            </Button>
                        ) : null}

                    </Grid>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Grid item>
                                <Paper variant="outlined" className={classes.status}>
                                    <Typography variant="overline" className={classes.statusTitle}>
                                        Document No.
                                    </Typography>
                                    <Divider className={classes.divider2} orientation="vertical" />
                                    {loading ? "Loading..." : state.documentNo}
                                    
                                </Paper>
                            </Grid>
                            &nbsp;&nbsp;&nbsp;
                            <Grid item>
                                <Paper
                                    variant="outlined"
                                    className={clsx(
                                        state.status === "draft"
                                            ? classes.statusYellow
                                            : state.status === "submitted"
                                                ? classes.statusOrange
                                                : (state.status === "reviewed" || state.status === "accepted")
                                                    ? classes.statusGreen
                                                    : (state.status === "approved" || state.status === "sent")
                                                        ? classes.statusDarkGreen
                                                        : classes.statusRed,
                                        classes.status
                                    )}
                                >
                                
                                <Typography variant="overline" className={classes.statusTitle2}>
                                    Status
                                </Typography>
                                <Divider className={classes.divider2} orientation="vertical" />
                                <Typography variant="overline" className={classes.statusTitle2}>
                                    {loading ? "Loading..." : state.status}
                                </Typography>

                                </Paper>
                            </Grid>
                        </Grid>                        
                    </Grid>
                </Grid>

                <Paper variant="outlined" square spacing={3} className={classes.paper}>
                    <div>
                        <Grid container spacing={2} className={classes.grid}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Employee Name"
                                    name="employeeName"
                                    variant="outlined"
                                    fullWidth
                                    onChange={handleChange}
                                    value={(state.createdBy && state.createdBy.userName) || ""}
                                    disabled
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                label="Change Request No"
                                name="requestNo"
                                variant="outlined"
                                fullWidth
                                value={(state.requestNo && state.requestNo) || ""}
                                disabled
                                required
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Division/Unit"
                                    name="division"
                                    variant="outlined"
                                    fullWidth
                                    onChange={handleChange}
                                    value={(state.division && state.division.name) || ""}
                                    disabled
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <DatePicker
                                    className={classes.marginBottom}
                                    autoOk
                                    format="DD/MM/yyyy"
                                    views={["year", "month", "date"]}
                                    label="Request Date"
                                    fullWidth
                                    required
                                    inputVariant="outlined"
                                    value={(state.requestDate && state.requestDate) || ""}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    multiline
                                    rows={2}
                                    label="Change Request Description"
                                    name="requestDescription"
                                    value={state.requestDescription || ""}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    multiline
                                    rows={2}
                                    label="Business or Technical Justification"
                                    name="justification"
                                    value={state.justification || ""}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="Resource Requirements"
                                    name="resourceRequirements"
                                    value={state.resourceRequirements || ""}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="Budget Projection"
                                    name="budgetProjection"
                                    value={state.budgetProjection || ""}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl
                                    fullWidth
                                    required
                                    variant="outlined"
                                    component="fieldset"
                                >
                                    <FormLabel style={{fontWeight: 'bold', color: "currentcolor"}}> 
                                        Priority 
                                    </FormLabel>
                                    <RadioGroup row disabled>
                                        <FormControlLabel
                                            value="Critical"
                                            control={<Radio checked={(state.priority === "Critical") ? true : false} />}
                                            label="Critical"
                                            name="priority"
                                        />
                                        <FormControlLabel
                                            value="High"
                                            control={<Radio checked={(state.priority === "High") ? true : false} />}
                                            label="High"
                                            name="priority"
                                        />
                                        <FormControlLabel
                                            value="Medium"
                                            control={<Radio checked={(state.priority === "Medium") ? true : false} />}
                                            label="Medium"
                                            name="priority"
                                        />
                                        <FormControlLabel
                                            value="Low"
                                            control={<Radio checked={(state.priority === "Low") ? true : false} />}
                                            label="Low"
                                            name="priority"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>

                        {/* Timelines Added */}
                        {(state.timelines && state.timelines.length > 0) ? 
                        <>
                            <Typography variant="overline" className={classes.title2}>
                                Project Timelines
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper0}>
                                {(state.timelines && state.timelines.length > 0) ? state.timelines.map((sitem, i) => (
                                    <Grid
                                        container
                                        spacing={2}
                                        className={classes.grid}
                                        key={i}
                                    >
                                        <Grid item xs={12} md={9}>
                                            <label style={{ fontWeight: "bold" }}>Action</label>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                required
                                                name="action"
                                                value={sitem.action || ""}
                                                disabled
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <label style={{ fontWeight: "bold" }}>Due Date</label>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                required
                                                name="dueDate"
                                                value={sitem.dueDate || ""}
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>
                                )) : <>
                                    <Typography variant="overline" className={classes.title2}>
                                        No Project Timeline added yet
                                    </Typography>
                                </>}
                            </Paper>
                        </> : null }

                        {/* Outcomes Added */}
                        {(state.outcomes && state.outcomes.length > 0) ? 
                        <>
                            <Typography variant="overline" className={classes.title2}>
                                Expected Outcomes
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper0}>
                                {(state.outcomes && state.outcomes.length > 0) ? state.outcomes.map((sitem, i) => (
                                    <Grid
                                        container
                                        spacing={2}
                                        className={classes.grid}
                                        key={i}
                                    >
                                        <Grid item xs={12} md={12}>
                                            <label style={{ fontWeight: "bold" }}>Description</label>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                required
                                                name="description"
                                                value={sitem.description || ""}
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>
                                )) : <>
                                    <Typography variant="overline" className={classes.title2}>
                                        No Expected Outcome added yet
                                    </Typography>
                                </>}
                            </Paper>
                        </> : null }
                    </div>
                </Paper>

                {((isCoordinator || isAdmin) && (state.status === "submitted")) ? <> 
                <Typography variant="overline" className={classes.title}>
                    Change Request Form Review
                </Typography>

                <Paper variant="outlined" square spacing={3} className={classes.paper}>
                    <div>
                        <Typography variant="overline" className={classes.title2}>
                            Driving Forces  
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            {driving ? (
                                <Grid
                                    container
                                    spacing={2}
                                    className={classes.grid}
                                >
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Description"
                                            name="description"
                                            value={(driving.description && driving.description) || ""}
                                            onChange={handleDrivingChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        <FormControl
                                            fullWidth
                                            required
                                            variant="outlined"
                                            component="fieldset"
                                        >
                                            <RadioGroup row onChange={handleDrivingChange}>
                                                <Grid item xs={6} md={3}>
                                                    <FormControlLabel
                                                        value="5"
                                                        control={<Radio checked={(driving.likelihood === "5") ? true : false} />}
                                                        label="Very Likely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={2}>
                                                    <FormControlLabel
                                                        value="4"
                                                        control={<Radio checked={(driving.likelihood === "4") ? true : false} />}
                                                        label="Likely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={2}>
                                                    <FormControlLabel
                                                        value="3"
                                                        control={<Radio checked={(driving.likelihood === "3") ? true : false} />}
                                                        label="Undecided"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={2}>
                                                    <FormControlLabel
                                                        value="2"
                                                        control={<Radio checked={(driving.likelihood === "2") ? true : false} />}
                                                        label="Unlikely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={3}>
                                                    <FormControlLabel
                                                        value="1"
                                                        control={<Radio checked={(driving.likelihood === "1") ? true : false} />}
                                                        label="Very Unlikely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={1}>
                                        <Fab
                                            color="primary"
                                            style={{ backgroundColor: "#1877F2" }}
                                            onClick={() => handleAddDrivingArray(driving)}
                                        >
                                            <AddIcon />
                                        </Fab>
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Paper>

                        <Typography variant="overline" className={classes.title2}>
                            Restraining Forces  
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            {restraining ? (
                                <Grid
                                    container
                                    spacing={2}
                                    className={classes.grid}
                                >
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Description"
                                            name="description"
                                            value={(restraining.description && restraining.description) || ""}
                                            onChange={handleRestrainingChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        <FormControl
                                            fullWidth
                                            required
                                            variant="outlined"
                                            component="fieldset"
                                        >
                                            <RadioGroup row onChange={handleRestrainingChange}>
                                                <Grid item xs={6} md={3}>
                                                    <FormControlLabel
                                                        value="5"
                                                        control={<Radio checked={(restraining.likelihood === "5") ? true : false} />}
                                                        label="Very Likely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={2}>
                                                    <FormControlLabel
                                                        value="4"
                                                        control={<Radio checked={(restraining.likelihood === "4") ? true : false} />}
                                                        label="Likely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={2}>
                                                    <FormControlLabel
                                                        value="3"
                                                        control={<Radio checked={(restraining.likelihood === "3") ? true : false} />}
                                                        label="Undecided"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={2}>
                                                    <FormControlLabel
                                                        value="2"
                                                        control={<Radio checked={(restraining.likelihood === "2") ? true : false} />}
                                                        label="Unlikely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={3}>
                                                    <FormControlLabel
                                                        value="1"
                                                        control={<Radio checked={(restraining.likelihood === "1") ? true : false} />}
                                                        label="Very Unlikely"
                                                        name="likelihood"
                                                    />
                                                </Grid>
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={1}>
                                        <Fab
                                            color="primary"
                                            style={{ backgroundColor: "#1877F2" }}
                                            onClick={() => handleAddRestrainingArray(restraining)}
                                        >
                                            <AddIcon />
                                        </Fab>
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Paper>

                        <Typography variant="overline" className={classes.title2}>
                            Change Request Resolution
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={6}>
                                    <FormControl
                                        fullWidth
                                        required
                                        variant="outlined"
                                        component="fieldset"
                                        disabled={(state.status === "reviewed") || (state.status === "accepted") || 
                                            (state.status === "approved")}
                                    >
                                        <FormLabel style={{fontWeight: 'bold', color: "currentcolor"}}> 
                                            Training Required
                                        </FormLabel>
                                        <RadioGroup row onChange={handleChange}>
                                            <FormControlLabel
                                                value="Yes"
                                                control={<Radio checked={(state.trainingRequired === "Yes") ? true : false} />}
                                                label="Yes"
                                                name="trainingRequired"
                                            />
                                            <FormControlLabel
                                                value="No"
                                                control={<Radio checked={(state.trainingRequired === "No") ? true : false} />}
                                                label="No"
                                                name="trainingRequired"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl
                                        fullWidth
                                        required
                                        variant="outlined"
                                        component="fieldset"
                                        disabled={(state.status === "reviewed") || (state.status === "accepted") || 
                                            (state.status === "approved")}
                                    >
                                        <FormLabel style={{fontWeight: 'bold', color: "currentcolor"}}> 
                                            Decision Recommendation
                                        </FormLabel>
                                        <RadioGroup row onChange={handleChange}>
                                            <FormControlLabel
                                                value="CEO"
                                                control={<Radio checked={(state.recommendation === "CEO") ? true : false} />}
                                                label="CEO"
                                                name="recommendation"
                                            />
                                            <FormControlLabel
                                                value="Advisory Board"
                                                control={<Radio checked={(state.recommendation === "Advisory Board") ? true : false} />}
                                                label="Advisory Board"
                                                name="recommendation"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Paper>
                    </div>
                </Paper>
                </> : null }

                {/* for default view  */}
                {((state.status === "submitted") || (state.status === "reviewed") || (state.status === "accepted") || (state.status === "approved")) ? <>

                <Paper variant="outlined" square spacing={3} className={classes.paper}>
                    <div>
                        {(state.drivingForces && state.drivingForces.length > 0) ?  <>
                            <Typography variant="overline" className={classes.title2}>
                                Driving Forces
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper2}>
                                <TableContainer>
                                    <Table bordered="true" className={classes.table} aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>SN</TableCell>
                                                <TableCell>Description</TableCell>
                                                <TableCell>Very Likely</TableCell>
                                                <TableCell>Likely</TableCell>
                                                <TableCell>Undecided</TableCell>
                                                <TableCell>Unlikely</TableCell>
                                                <TableCell>Very Unlikely</TableCell>
                                                {state.status === "submitted" ? 
                                                <TableCell>Remove</TableCell> : null }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {state.drivingForces && state.drivingForces.map((sitem, i) => (
                                            <TableRow key={i}>
                                                <TableCell component="th" scope="row">{i + 1}</TableCell>
                                                <TableCell component="th" scope="row">{sitem.description || ""}</TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="5"
                                                        control={<Radio checked={(sitem.likelihood === "5") ? true : false} />}
                                                        label="Very Likely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="4"
                                                        control={<Radio checked={(sitem.likelihood === "4") ? true : false} />}
                                                        label="Likely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="3"
                                                        control={<Radio checked={(sitem.likelihood === "3") ? true : false} />}
                                                        label="Undecided"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="2"
                                                        control={<Radio checked={(sitem.likelihood === "2") ? true : false} />}
                                                        label="Unlikely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="1"
                                                        control={<Radio checked={(sitem.likelihood === "1") ? true : false} />}
                                                        label="Very Likely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                {state.status === "submitted" ? 
                                                <TableCell component="th" scope="row">
                                                    <Fab
                                                        color="secondary"
                                                        onClick={() => handleRemoveDrivingArray(i)}
                                                    >
                                                        <CloseIcon />
                                                    </Fab>
                                                </TableCell> : null }
                                            </TableRow>
                                        ))}
                                            <TableRow>
                                                <TableCell component="th" scope="row" colSpan={2}>
                                                    Total:
                                                </TableCell>
                                                <TableCell component="th" scope="row" colSpan={6}>
                                                    {(state.totalDrivingForces && state.totalDrivingForces) || 0}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper> </> : null 
                        }

                        {(state.restrainingForces && state.restrainingForces.length > 0) ? <>
                            <Typography variant="overline" className={classes.title2}>
                                Restraining Forces
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper2}>
                                <TableContainer>
                                    <Table bordered="true" className={classes.table} aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>SN</TableCell>
                                                <TableCell>Description</TableCell>
                                                <TableCell>Very Likely</TableCell>
                                                <TableCell>Likely</TableCell>
                                                <TableCell>Undecided</TableCell>
                                                <TableCell>Unlikely</TableCell>
                                                <TableCell>Very Unlikely</TableCell>
                                                {state.status === "submitted" ? 
                                                <TableCell>Remove</TableCell> : null }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {state.restrainingForces && state.restrainingForces.map((sitem, i) => (
                                            <TableRow key={i}>
                                                <TableCell component="th" scope="row">{i + 1}</TableCell>
                                                <TableCell component="th" scope="row">{sitem.description || ""}</TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="5"
                                                        control={<Radio checked={(sitem.likelihood === "5") ? true : false} />}
                                                        label="Very Likely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="4"
                                                        control={<Radio checked={(sitem.likelihood === "4") ? true : false} />}
                                                        label="Likely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="3"
                                                        control={<Radio checked={(sitem.likelihood === "3") ? true : false} />}
                                                        label="Undecided"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="2"
                                                        control={<Radio checked={(sitem.likelihood === "2") ? true : false} />}
                                                        label="Unlikely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControlLabel
                                                        value="1"
                                                        control={<Radio checked={(sitem.likelihood === "1") ? true : false} />}
                                                        label="Very Likely"
                                                        disabled
                                                    />
                                                </TableCell>
                                                {state.status === "submitted" ? 
                                                <TableCell component="th" scope="row">
                                                    <Fab
                                                        color="secondary"
                                                        onClick={() => handleRemoveRestrainingArray(i)}
                                                    >
                                                        <CloseIcon />
                                                    </Fab>
                                                </TableCell> : null }
                                            </TableRow>
                                        ))}
                                            <TableRow>
                                                <TableCell component="th" scope="row" colSpan={2}>
                                                    Total:
                                                </TableCell>
                                                <TableCell component="th" scope="row" colSpan={6}>
                                                    {(state.totalRestrainingForces && 
                                                        state.totalRestrainingForces) || 0}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper> </> : null 
                        }

                        {(state.trainingRequired && state.recommendation && state.status !== "submitted") ? <>
                        <Typography variant="overline" className={classes.title2}>
                            Change Request Resolution
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={state.status === "approved" ? 4 : 6}>
                                    <FormControl
                                        fullWidth
                                        required
                                        variant="outlined"
                                        component="fieldset"
                                        disabled={(state.status === "reviewed") || (state.status === "accepted") || 
                                            (state.status === "approved")}
                                    >
                                        <FormLabel style={{fontWeight: 'bold', color: "currentcolor"}}> 
                                            Training Required
                                        </FormLabel>
                                        <RadioGroup row onChange={handleChange}>
                                            <FormControlLabel
                                                value="Yes"
                                                control={<Radio checked={(state.trainingRequired === "Yes") ? true : false} />}
                                                label="Yes"
                                                name="trainingRequired"
                                            />
                                            <FormControlLabel
                                                value="No"
                                                control={<Radio checked={(state.trainingRequired === "No") ? true : false} />}
                                                label="No"
                                                name="trainingRequired"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={state.status === "approved" ? 4 : 6}>
                                    <FormControl
                                        fullWidth
                                        required
                                        variant="outlined"
                                        component="fieldset"
                                        disabled={(state.status === "reviewed") || (state.status === "accepted") || 
                                            (state.status === "approved")}
                                    >
                                        <FormLabel style={{fontWeight: 'bold', color: "currentcolor"}}> 
                                            Decision Recommendation
                                        </FormLabel>
                                        <RadioGroup row onChange={handleChange}>
                                            <FormControlLabel
                                                value="CEO"
                                                control={<Radio checked={(state.recommendation === "CEO") ? true : false} />}
                                                label="CEO"
                                                name="recommendation"
                                            />
                                            <FormControlLabel
                                                value="Advisory Board"
                                                control={<Radio checked={(state.recommendation === "Advisory Board") ? true : false} />}
                                                label="Advisory Board"
                                                name="recommendation"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                {state.status === "approved" ? <>
                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth required variant="outlined" component="fieldset"
                                        disabled={state.status !== "accepted"}
                                    >
                                        <FormLabel style={{fontWeight: 'bold', color: "currentcolor"}}> 
                                            Change Request Resolution
                                        </FormLabel>
                                        <RadioGroup row onChange={handleChange} >
                                            <FormControlLabel
                                                value="Approved"
                                                control={<Radio checked={(state.decision === "Approved") ? true : false} />}
                                                label="Approved"
                                                name="decision"
                                            />
                                            <FormControlLabel
                                                value="On Hold"
                                                control={<Radio checked={(state.decision === "On Hold") ? true : false} />}
                                                label="On Hold"
                                                name="decision"
                                            />
                                            <FormControlLabel
                                                value="Denied"
                                                control={<Radio checked={(state.decision === "Denied") ? true : false} />}
                                                label="Denied"
                                                name="decision"
                                            />
                                            <FormControlLabel
                                                value="Deferred"
                                                control={<Radio checked={(state.decision === "Deferred") ? true : false} />}
                                                label="Deferred"
                                                name="decision"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid></> : null}

                            </Grid>
                        </Paper> </> : null }
                    </div>
                </Paper>
                </> : null }

                <Paper variant="outlined" square spacing={3} className={classes.paper}>
                    {(state.status === "reviewed") ? <>
                        <Typography variant="overline" className={classes.title2}>
                            Risk Factors
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            {riskFactor ? (
                                <Grid
                                    container
                                    spacing={2}
                                    className={classes.grid}
                                >
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Risk"
                                            name="risk"
                                            value={(riskFactor.risk && riskFactor.risk) || ""}
                                            onChange={handleRiskFactorChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Action"
                                            name="action"
                                            value={(riskFactor.action && riskFactor.action) || ""}
                                            onChange={handleRiskFactorChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Responsibility"
                                            name="responsibility"
                                            value={(riskFactor.responsibility && riskFactor.responsibility) || ""}
                                            onChange={handleRiskFactorChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Timeline"
                                            name="timeline"
                                            value={(riskFactor.timeline && riskFactor.timeline) || ""}
                                            onChange={handleRiskFactorChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={1}>
                                        <Fab
                                            color="primary"
                                            style={{ backgroundColor: "#1877F2" }}
                                            onClick={() => handleAddRiskFactorsArray(riskFactor)}
                                            disabled={(state.status !== "reviewed")}
                                        >
                                            <AddIcon />
                                        </Fab>
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Paper>

                        <Typography variant="overline" className={classes.title2}>
                            Opportunity Factors
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            {opportunityFactor ? (
                                <Grid
                                    container
                                    spacing={2}
                                    className={classes.grid}
                                >
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Risk"
                                            name="risk"
                                            value={(opportunityFactor.risk && opportunityFactor.risk) || ""}
                                            onChange={handleOpportunityFactorChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Action"
                                            name="action"
                                            value={(opportunityFactor.action && opportunityFactor.action) || ""}
                                            onChange={handleOpportunityFactorChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Responsibility"
                                            name="responsibility"
                                            value={(opportunityFactor.responsibility && opportunityFactor.responsibility) || ""}
                                            onChange={handleOpportunityFactorChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Timeline"
                                            name="timeline"
                                            value={(opportunityFactor.timeline && opportunityFactor.timeline) || ""}
                                            onChange={handleOpportunityFactorChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={1}>
                                        <Fab
                                            color="primary"
                                            style={{ backgroundColor: "#1877F2" }}
                                            onClick={() => handleAddOpportunityFactorsArray(opportunityFactor)}
                                            disabled={(state.status !== "reviewed")}
                                        >
                                            <AddIcon />
                                        </Fab>
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Paper>
                    </> : null }

                    {((state.status === "submitted") || (state.status === "reviewed") || (state.status === "accepted") || (state.status === "approved")) ? <>

                        {(state.riskFactors && state.riskFactors.length > 0) ?  <>
                            <Typography variant="overline" className={classes.title2}>
                                Risk Factors
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper2}>
                                <TableContainer>
                                    <Table bordered="true" className={classes.table} aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>SN</TableCell>
                                                <TableCell>Risk</TableCell>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Responsibility</TableCell>
                                                <TableCell>Timeline</TableCell>
                                                {state.status === "reviewed" ? 
                                                <TableCell>Remove</TableCell> : null }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {state.riskFactors && state.riskFactors.map((sitem, i) => (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row">{i + 1}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.risk || ""}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.action || ""}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.responsibility || ""}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.timeline || ""}</TableCell>
                                                    {state.status === "reviewed" ? 
                                                    <TableCell component="th" scope="row">
                                                        <Fab
                                                            color="secondary"
                                                            onClick={() => handleRemoveRiskFactorsArray(i)}
                                                        >
                                                            <CloseIcon />
                                                        </Fab>
                                                    </TableCell> : null }
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper> </> : null 
                        }

                        {(state.opportunityFactors && state.opportunityFactors.length > 0) ?  <>
                            <Typography variant="overline" className={classes.title2}>
                                Opportunity Factors
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper2}>
                                <TableContainer>
                                    <Table bordered="true" className={classes.table} aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>SN</TableCell>
                                                <TableCell>Risk</TableCell>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Responsibility</TableCell>
                                                <TableCell>Timeline</TableCell>
                                                {state.status === "reviewed" ? 
                                                <TableCell>Remove</TableCell> : null }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {state.opportunityFactors && state.opportunityFactors.map((sitem, i) => (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row">{i + 1}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.risk || ""}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.action || ""}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.responsibility || ""}</TableCell>
                                                    <TableCell component="th" scope="row">{sitem.timeline || ""}</TableCell>
                                                    {state.status === "reviewed" ? 
                                                    <TableCell component="th" scope="row">
                                                        <Fab
                                                            color="secondary"
                                                            onClick={() => handleRemoveOpportunityFactorsArray(i)}
                                                        >
                                                            <CloseIcon />
                                                        </Fab>
                                                    </TableCell> : null }
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper> </> : null 
                        } 
                        
                    </> : null }
    
                    {/* for ceo final approval  */}
                    {(isBoard || isAdmin) && (state.status === "accepted") ? <>
                        <Typography variant="overline" className={classes.title}>
                            Change Impact Assessment
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={12}>
                                    <FormControl fullWidth required variant="outlined" component="fieldset"
                                        disabled={state.status !== "accepted"}
                                    >
                                        <FormLabel style={{fontWeight: 'bold', color: "currentcolor"}}> 
                                            Change Request Resolution
                                        </FormLabel>
                                        <RadioGroup row onChange={handleChange} >
                                            <FormControlLabel
                                                value="Approved"
                                                control={<Radio checked={(state.decision === "Approved") ? true : false} />}
                                                label="Approved"
                                                name="decision"
                                            />
                                            <FormControlLabel
                                                value="On Hold"
                                                control={<Radio checked={(state.decision === "On Hold") ? true : false} />}
                                                label="On Hold"
                                                name="decision"
                                            />
                                            <FormControlLabel
                                                value="Denied"
                                                control={<Radio checked={(state.decision === "Denied") ? true : false} />}
                                                label="Denied"
                                                name="decision"
                                            />
                                            <FormControlLabel
                                                value="Deferred"
                                                control={<Radio checked={(state.decision === "Deferred") ? true : false} />}
                                                label="Deferred"
                                                name="decision"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Paper>
                    </> : null }

                    <Grid container alignItems="center" wrap="nowrap" spacing={1} style={{ marginBottom: 5 }}>
                        <Grid item>
                            <Typography variant="overline" className={classes.title2}>
                                Audit Trail
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Icon className="fas fa-clipboard-list" color="disabled" />
                        </Grid>
                    </Grid>

                    <Paper variant="outlined" square className={classes.paper}>
                        <Grid container justify="space-between" alignItems="center" spacing={2}>
                            {state.status === "draft" && (
                                <Grid item xs={12} md={12}>
                                    <Paper
                                        className={classes.auditContainer}
                                        component="div"
                                        elevation={1}
                                        variant="outlined"
                                        square
                                    >
                                        <span className={classes.auditTitle}>Created By</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.createdBy && state.createdBy.userName}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.createdAt}</span>
                                    </Paper>
                                </Grid>
                            )}
                            {state.status !== "draft" && (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Submitted By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.submittedBy && state.submittedBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.submittedAt}</span>
                                        </Paper>
                                    </Grid>
                                    {(state.reviewedAt && state.reviewedBy) && (
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <Paper
                                                    className={classes.auditContainer}
                                                    component="div"
                                                    elevation={1}
                                                    variant="outlined"
                                                    square
                                                >
                                                    <span className={classes.auditTitle}>Reviewed By</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.reviewedBy && state.reviewedBy.userName}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.reviewedAt}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.auditTitle}>Comment</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.reviewComment}</span>
                                                </Paper>
                                            </Grid>
                                        </>
                                    )}
                                    {(state.declinedAt && state.declinedBy) && (
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <Paper
                                                    className={classes.auditContainer}
                                                    component="div"
                                                    elevation={1}
                                                    variant="outlined"
                                                    square
                                                >
                                                    <span className={classes.auditTitle}>Declined By</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.declinedBy && state.declinedBy.userName}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.declinedAt}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.auditTitle}>Comment</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.declineComment}</span>
                                                </Paper>
                                            </Grid>
                                        </>
                                    )}

                                    {(state.acceptedAt && state.acceptedBy) && (
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <Paper
                                                    className={classes.auditContainer}
                                                    component="div"
                                                    elevation={1}
                                                    variant="outlined"
                                                    square
                                                >
                                                    <span className={classes.auditTitle}>Accepted By</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.acceptedBy && state.acceptedBy.userName}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.acceptedAt}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.auditTitle}>Comment</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.acceptComment}</span>
                                                </Paper>
                                            </Grid>
                                        </>
                                    )}
                                    {(state.unacceptedAt && state.unacceptedBy) && (
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <Paper
                                                    className={classes.auditContainer}
                                                    component="div"
                                                    elevation={1}
                                                    variant="outlined"
                                                    square
                                                >
                                                    <span className={classes.auditTitle}>Unaccepted By</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.unacceptedBy && state.unacceptedBy.userName}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.unacceptedAt}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.auditTitle}>Comment</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.unacceptComment}</span>
                                                </Paper>
                                            </Grid>
                                        </>
                                    )}

                                    {(state.approvedAt && state.approvedBy) && (
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <Paper
                                                    className={classes.auditContainer}
                                                    component="div"
                                                    elevation={1}
                                                    variant="outlined"
                                                    square
                                                >
                                                    <span className={classes.auditTitle}>Approved By</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.approvedBy && state.approvedBy.userName}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.approvedAt}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.auditTitle}>Comment</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.approveComment}</span>
                                                </Paper>
                                            </Grid>
                                        </>
                                    )}
                                    {(state.rejectedAt && state.rejectedBy) && (
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <Paper
                                                    className={classes.auditContainer}
                                                    component="div"
                                                    elevation={1}
                                                    variant="outlined"
                                                    square
                                                >
                                                    <span className={classes.auditTitle}>Rejected By</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.rejectedBy && state.rejectedBy.userName}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.rejectedAt}</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.auditTitle}>Comment</span>
                                                    <Divider orientation="vertical" flexItem />
                                                    <span className={classes.audit}>{state.rejectComment}</span>
                                                </Paper>
                                            </Grid>
                                        </>
                                    )}
                                </>
                            )}
                        </Grid>
                    </Paper>

                    {(isCoordinator || isAdmin) && state.status === "submitted" ? (
                        <Grid container justify="center">
                            <Grid item>
                                <div className={classes.centered}>
                                    <Paper className={classes.paperBlack}>
                                        <HelpOutlineIcon fontSize="large" />
                                        <Typography placeholder="Info" className={classes.info2}>
                                            This change request form review or decline is to be done by the Change Coordinator.
                                        </Typography>
                                    </Paper>
                                </div>
                                <ButtonGroup>
                                    <Button
                                        onClick={handleOpenReview}
                                        className={classes.saveBtn2}
                                        variant="contained"
                                        disabled={loading || validReviewCheck() }
                                    >
                                        Review
                                    </Button>
                                    <Button
                                        onClick={handleOpenDecline}
                                        className={classes.saveBtn}
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Decline
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ) : null}

                    {(isQHSEHead || isAdmin) && state.status === "reviewed" ? (
                        <Grid container justify="center">
                            <Grid item>
                                <div className={classes.centered}>
                                    <Paper className={classes.paperBlack}>
                                        <HelpOutlineIcon fontSize="large" />
                                        <Typography placeholder="Info" className={classes.info2}>
                                            These actions are to be done by the Business Sustainability Division Manager.
                                        </Typography>
                                    </Paper>
                                </div>
                                <ButtonGroup>
                                    <Button
                                        onClick={handleOpenAccept}
                                        className={classes.saveBtn2}
                                        variant="contained"
                                        disabled={loading || validAcceptCheck() }
                                    >
                                        Accept
                                    </Button>
                                    <Button
                                        onClick={handleOpenUnaccept}
                                        className={classes.saveBtn}
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Not Accept
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ) : null}

                    {(isBoard || isAdmin) && state.status === "accepted" ? (
                        <Grid container justify="center">
                            <Grid item>
                                <div className={classes.centered}>
                                    <Paper className={classes.paperBlack}>
                                        <HelpOutlineIcon fontSize="large" />
                                        <Typography placeholder="Info" className={classes.info2}>
                                            This change request resolution action is to be carried out by the 
                                            Chief Executive Officer. Please select the change request resolution decision before approving.
                                        </Typography>
                                    </Paper>
                                </div>
                                <ButtonGroup>
                                    <Button
                                        onClick={handleOpenApprove}
                                        className={classes.saveBtn2}
                                        variant="contained"
                                        disabled={loading || validApproveCheck() }
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                        onClick={handleOpenReject}
                                        className={classes.saveBtn}
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Reject
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ) : null}
            </Paper>

            </MuiPickersUtilsProvider>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default ViewChangeRequest;
